/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {service as RelationshipService} from "../../../Services/RelationshipService";

export class RelationshipFieldViewer extends BaseFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			relationships: []
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		RelationshipService.Get()
			.then((x) => {
				this.setState({relationships: x.result});
			});
	}

	@autobind
	getRelationship() {
		return this.state.relationships.find((x) => x.relationshipId == this.props.Value);
	}

	@autobind
	_render() {
		let relationship = this.getRelationship();

		return relationship ? relationship.name : "N/A";
	}
}